import React from "react";

export default function TurnVisitSection({styles}) {
    return (
        <section className={`${styles.container} ${styles.turnVisitSection}`}>

          <div className={`${styles.container} ${styles.turnVisitHeading}`}>
            <div className={styles.headingContainer}>
              <h1 className={styles.sectionTitle}>
                Turn Every Visitor Into a Revenue Stream
              </h1>
              <p className={styles.sectionSubTitle}>
                Capture emails with high-converting signup forms, then automatically nurture leads with personalized welcome sequences that transform browsers into buyers.
              </p>
            </div>
          </div>
          
            <div className={styles.turnVisitImageContainer}>
              <img
                className={styles.turnVisitImage}
                src="/images/turnVisitor.webp"
                alt="Screenshot example."
              />
            </div>
        </section>  
    )};